import React, { PropsWithChildren } from 'react'

export default function SubtitleWrapper({ children }: PropsWithChildren) {
  return (
    <div className="flex items-center gap-2 [&>:not(:last-child)]:border-r [&>:not(:last-child)]:pr-2 [&>:not(:last-child)]:border-defaultBorder">
      {children}
    </div>
  )
}
